import PropTypes from 'prop-types';
import CssClassMixin from '../../mixins/css_class_mixin.jsx';

var createClass = require('create-react-class');

window.ModalHeader = createClass({
  mixins: [CssClassMixin],

  propTypes: {
    withTitle: PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      themeClassKey: 'modal.header',
      withTitle: true
    };
  },

  render: function() {
    return <div className={this.getClassName()}>{this.props.children}</div>;
  },

  getClassName: function() {
    var className = Realize.themes.getCssClass(this.props.themeClassKey);
    if(!this.props.clearTheme && this.props.withTitle) {
      className += ' '+ Realize.themes.getCssClass('modal.header.withTitle');
    }

    return className;
  }
});